import { styled } from "styled-components";

export const RadioGroupCheckboxFieldset = styled.fieldset`
    margin-top: 0.5rem;
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
`;
